import styled, { css } from 'styled-components'

import { Card as DefaultCard } from '@/components/ui/card'

export const Card = styled(DefaultCard)({
  flex: 1,
  height: 'auto',
})

export const Section = styled(DefaultCard)({
  flexShrink: 0,
  height: 'auto',
})

export const Header = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: ${theme.space['8']};
  `,
)
